import { defineComponent as _defineComponent } from 'vue';
import { Label as RekaLabel } from 'reka-ui';
import { cva } from 'class-variance-authority';
import { cn } from '../utils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Label',
    props: {
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true },
        disabled: { type: Boolean, required: false },
        labelOnLeft: { type: Boolean, required: false },
        for: { type: String, required: false },
        asChild: { type: Boolean, required: false },
        as: { type: null, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const labelVariants = cva('text-sm font-medium text-foreground mb-1', {
            variants: {
                disabled: { true: 'opacity-50', false: '' },
                labelOnLeft: { true: 'shrink-0 pt-2 text-right', false: '' },
            },
        });
        const __returned__ = { props, labelVariants, get RekaLabel() { return RekaLabel; }, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
